var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"commentModal",attrs:{"hide-footer":"","title":"Notes","scrollable":"","centered":"","lazy":"","size":"md"},on:{"hide":_vm.hideModal}},[_c('p',[_vm._v(" "+_vm._s(_vm.comment)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }